import React, { useRef } from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { addExtra } from 'apps/auth/actions/extraAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import { getField } from 'apps/auth/components/form-multi/utils';
import ChangePasswordPopup from 'apps/auth/components/profile/settings/ChangePasswordPopup';
import ProfileSmsConfirmModal from 'apps/auth/components/profile/settings/ProfileSmsConfirmModal';
import BasePage from 'apps/auth/components/utils/BasePage';
import { SMS_CONFIRMATION } from 'apps/auth/constants/ExtraNames';
import { AUTH_CHANGE_PASSWORD, AUTH_RESET_PASSWORD_ACTION, AUTH_SECURITY } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';

const SettingsPage = (props) => {
    const popupRef = useRef(null);
    const hasPass = props.data.hasPassword;

    const changePassword = (e) => {
        e.preventDefault();
        if (hasPass) {
            apiFetchData(AUTH_RESET_PASSWORD_ACTION, { password: getField('password', !hasPass) }).then((json) => {
                props.updatePageMessages(json.messages);
                if (json.extra && json.extra.smsConfirmation) {
                    props.addExtra(SMS_CONFIRMATION, json.extra.smsConfirmation).then(() => props.toggleModal(true, <ProfileSmsConfirmModal />));
                }
            });
        } else {
            window.location.href = AUTH_CHANGE_PASSWORD;
        }
    };

    return (
        <>
            <CommonPage showChat={false} backUrl={AUTH_SECURITY}>
                {!hasPass ? (
                    <HeaderPanel
                        title={props.headerTitle}
                        subtitle={props.headerGrayTitle}
                        buttonRowCaption={props.settingsResetTitle}
                        buttonRowOnClick={(e) => changePassword(e)}
                        buttonRowHref={AUTH_RESET_PASSWORD_ACTION}
                        addTopMargin
                    />
                ) : (
                    <>
                        <HeaderPanel title={props.headerTitle} subtitle={props.headerGrayTitle} />
                        <Row flex align="center" justify="between">
                            <div>
                                <Text size="secondary" color="secondary" variant="div">
                                    {props.settingsPasswordTitle}
                                </Text>
                                <Text variant="div">••••••••••</Text>
                            </div>
                            <DiskButton iconName="pencil" type="tagA" onClick={() => popupRef.current?.open(<ChangePasswordPopup popupRef={popupRef} />)} />
                        </Row>
                    </>
                )}
            </CommonPage>
            <PopupNew ref={popupRef} />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        headerTitle: state.messages.pageMessages.headerTitle,
        headerGrayTitle: state.messages.pageMessages.headerGrayTitle,
        settingsResetTitle: state.messages.pageMessages.settingsResetTitle,
        settingsPasswordTitle: state.messages.pageMessages.settingsPasswordTitle,
    };
};

export default connect(mapStateToProps, {
    toggleModal,
    updatePageMessages,
    addExtra,
})(BasePage(SettingsPage));
